const React = require("react")
const NiceModal = require("@ebay/nice-modal-react")
const {GoogleReCaptchaProvider} = require("@google-recaptcha/react")

exports.wrapRootElement = ({ element }) => {
  const RECAPTCHA_SITE_KEY = process.env.GATSBY_RECAPTCHA_SITE_KEY;
  return (
    <NiceModal.Provider>
      <GoogleReCaptchaProvider
        type="v3"
        siteKey={RECAPTCHA_SITE_KEY}
        isEnterprise={true}
      >
        {element}
      </GoogleReCaptchaProvider>
    </NiceModal.Provider>
  )
}

// Apply the same-tab / new-tab link rule to every link on the page, including
// plain <a> tags and links inside Drupal-rendered HTML.
exports.onInitialClientRender = () => {
  const { applyLinkTargets } = require("./src/utils/link-target")
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === "attributes") {
        applyLinkTargets(mutation.target)
      } else {
        mutation.addedNodes.forEach(node => node.nodeType === 1 && applyLinkTargets(node))
      }
    }
  })
  applyLinkTargets(document.body)
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["href"] })
}
